// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZMh5qQoytloegoWy0geq{display:none}.z3T7AvdUkjMo7eSJnke7{width:21cm;min-height:29.7cm}@media print{.ZMh5qQoytloegoWy0geq{display:block}}`, "",{"version":3,"sources":["webpack://./src/components/FinishSetup/FirstPrintButton.module.scss"],"names":[],"mappings":"AAAA,sBACC,YAAA,CAGD,sBACC,UAAA,CACA,iBAAA,CAGD,aACC,sBACC,aAAA,CAAA","sourcesContent":[".framePage {\n\tdisplay: none;\n}\n\n.page {\n\twidth: 21cm;\n\tmin-height: 29.7cm;\n}\n\n@media print {\n\t.framePage {\n\t\tdisplay: block;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"framePage": `ZMh5qQoytloegoWy0geq`,
	"page": `z3T7AvdUkjMo7eSJnke7`
};
export default ___CSS_LOADER_EXPORT___;
